import { useCallback } from 'react';

import { useOpalUser } from '@frontend/hooks';

import { getAnalyticsBrowser } from './analytics';
import type { TrackingEvents } from './events';

type TrackArgs<E extends keyof TrackingEvents> =
  Record<string, never> extends TrackingEvents[E]
    ? [eventName: E, payload?: TrackingEvents[E]]
    : [eventName: E, payload: TrackingEvents[E]];

export type TrackFn = <E extends keyof TrackingEvents>(...args: TrackArgs<E>) => void;

export function useTracking(): { track: TrackFn } {
  const { opalUser } = useOpalUser();

  const track = useCallback(
    (eventName: string, payload?: Record<string, unknown>): void => {
      const analytics = getAnalyticsBrowser();
      if (!analytics) return;
      void analytics.track(`Opal - ${eventName}`, {
        ...payload,
        userId: opalUser.email,
        groupId: opalUser.instance?.customer_id || '',
        productName: 'Opal App',
        subProductName: opalUser.instance?.product_sku || '',
        isOptiUser: opalUser.email?.endsWith('@optimizely.com') ? true : false,
      });
    },
    [opalUser]
  );

  return { track: track as TrackFn };
}
